<script setup>
import { onMounted } from 'vue';
import { useChatStore } from './stores/chat';
import Navigation from './components/Navigation.vue';

const { labels } = window.DATAGENT_PLUGIN_CHAT;
const chatStore = useChatStore();

onMounted(() => {
  chatStore.init();
});
</script>

<template>
  <div class="dataagent-chat">
    <!-- Header Section -->
    <div class="dataagent-section-header da:flex da:justify-between da:items-center da:pr-4">
      <div class="da:flex da:justify-center da:items-center da:space-x-3">
        <img :src="chatStore.settings.logo" alt="DataAgent" class="da:w-10 da:h-10" />
        <h1 class="da:text-lg da:text-gray-800 da:m-0">{{ labels.title }}</h1>
      </div>

      <!-- Upgrade -->
      <div v-if="!chatStore.quota.isPremium">
        <a
          :href="chatStore.settings.upgradeUrl"
          class="button-primary da:inline-block da:text-white da:px-5 da:py-2 da:rounded-lg da:transition-colors da:no-underline"
        >
          <i class="fas fa-bolt da:mr-2 da:font-yellow-300"></i>
          <span>
            {{ chatStore.labels.upgrade_btn }}
          </span>
        </a>
      </div>
    </div>

    <div class="da:bg-white da:border-2 da:border-gray-200 da:rounded-lg da:shadow-sm da:mr-4">
      <!-- Navigation Component with Tabs -->
      <Navigation />
    </div>

    
  </div>
</template>
